// extracted by mini-css-extract-plugin
module.exports =  {"container":"FreeTextQuestion__container--e6989"};